import React, { useEffect, useState } from "react";
import CreateBtn from "../../../components/buttons/createBtn";
import searcher from "../../../assets/searchInput.svg";
import VersionHistoryBtn from "../../../components/buttons/versionHistoryBtn";
import FieldForceDesTable from "./FieldForceDesTable";
import EnableDisableModal from "../../../components/modals/enableDisableModal";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

const FieldForceDesignationList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";

  const filterData = {
    approval_limit_from: queryParamsData.get("approval_limit_from") ?? "",
    approval_limit_to: queryParamsData.get("approval_limit_to") ?? "",
  };

  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");

  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/designation/:1",
      breadcrumb: " / field force / designation",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const queryParams = [];
  if (filterData?.approval_limit_from)
    queryParams.push(`approval_limit_from=${filterData?.approval_limit_from}`);
  if (filterData?.approval_limit_to)
    queryParams.push(`approval_limit_to=${filterData?.approval_limit_to}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
          <div>
            <div className="search-container d-flex justify-content-between align-items-center">
              <div className="search-box d-flex  align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} alt="o" />
                <input
                  value={search}
                  className="search-input text-dark fw_400 px-2"
                  type="text"
                  placeholder="Search Designation ID, Designation Name, etc."
                  onChange={(e) => {
                    navigate(
                      `/field-force/designation?page=1${
                        e.target.value ? `&search=${e.target.value}` : ""
                      }${queryString}`
                    );
                  }}
                />
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <button
                  onClick={() => navigate(`/field-force/designation`)}
                  className="border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
                >
                  Clear Filters
                </button>
                <VersionHistoryBtn link="/field-force/designation/version-history" />
                {(user_type === "super_user" && userData?.write) ||
                user_type === "vendor" ? (
                  <CreateBtn link="/field-force/designation/create" />
                ) : (
                  ""
                )}
              </div>
            </div>
            <FieldForceDesTable
              search={search}
              page_no={page_no}
              filterData={filterData}
            />
          </div>
        </div>
      </div>
      <EnableDisableModal />
    </div>
  );
};

export default FieldForceDesignationList;
